import { Component } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { IBottomSheetComponent } from '@m4u-angular/core/framework/bottom-sheet.service';
import { BottomSheetDialogComponent } from '@m4u-angular/ui/dialogs/bottom-sheet-dialog/bottom-sheet-dialog.component';

@Component({
    selector: 'app-bottom-sheet-context-menu',
    templateUrl: './bottom-sheet-context-menu.component.html',
    styleUrls: ['./bottom-sheet-context-menu.component.scss']
})
export class BottomSheetContextMenuComponent implements IBottomSheetComponent {
    MenuItems: ContextMenuElement[];
    Context: BottomSheetDialogComponent;
    get MenuItemsFiltered() {
        return this.MenuItems?.filter(x => !(x as any).separator);
    }

    constructor() {}

    OnItemClick(contextMenu) {
        contextMenu.onClick && contextMenu.onClick() 
            || contextMenu.command && contextMenu.command();
        this.Context.ClosePage();
    }
}
